// Feature flags configuration
export const FEATURE_FLAGS = {
  // Admin emails that can see unreleased features
  ADMIN_EMAILS: ['gambgomobile@gmail.com', 'ride@gmail.com'],
  
  // Ride driver emails - these accounts go to ride driver dashboard
  RIDE_DRIVER_EMAILS: ['ride@gmail.com'],

  // Emails allowed to preview the International Markets (Shop Abroad) feature
  INTERNATIONAL_MARKETS_EMAILS: ['gambgomobile@gmail.com'],

  // Emails allowed to preview the live Order Tracking feature (admins + these emails)
  ORDER_TRACKING_EMAILS: ['omar@gambgoexpress.com'],

  // Emails allowed to preview the new bottom navigation with an Orders tab
  ORDERS_TAB_EMAILS: ['omar@gambgoexpress.com'],

  // Emails allowed to preview the redesigned marketplace (home-page style layout)
  NEW_MARKETPLACE_EMAILS: ['omar@gambgoexpress.com', 'gambgomobile@gmail.com'],

  // Emails allowed to preview card payments via Waychit (admins + these emails)
  CARD_PAYMENTS_EMAILS: ['omar@gambgoexpress.com'],

  // Feature toggles
  MARKETPLACE_ENABLED: true, // Marketplace is now live!
};

export const isCardPaymentsUser = (
  email: string | undefined | null,
  isAdmin?: boolean,
): boolean => {
  if (isAdmin) return true;
  const e = (email || '').toLowerCase().trim();
  return (
    FEATURE_FLAGS.CARD_PAYMENTS_EMAILS.some((a) => a.toLowerCase() === e) ||
    FEATURE_FLAGS.ADMIN_EMAILS.some((a) => a.toLowerCase() === e)
  );
};


export const isRideDriverEmail = (email: string | undefined | null): boolean => {
  return FEATURE_FLAGS.RIDE_DRIVER_EMAILS.includes(email || '');
};

export const isInternationalMarketsUser = (email: string | undefined | null): boolean => {
  return FEATURE_FLAGS.INTERNATIONAL_MARKETS_EMAILS.includes(email || '');
};

export const isOrderTrackingUser = (
  _email: string | undefined | null,
  _isAdmin: boolean,
): boolean => {
  // Order tracking is now public for all authenticated users.
  return true;
};

export const isOrdersTabUser = (_email?: string | null): boolean => {
  // Orders tab is now public for everyone.
  return true;
};

export const isNewMarketplaceUser = (_email?: string | null): boolean => {
  // Redesigned marketplace is now public for everyone.
  return true;
};
